<frontmania-dynamic-form
  [formDefinitionInput]="formDefinitionInput$$.asObservable() | async"
  [formName]="formName"
  (saveSearch)="saveSearchReceived($event)"
  (submitEvent)="formSubmitReceived($event)"
  (resetEvent)="formResetReceived()">
</frontmania-dynamic-form>


